import a,{useState as P}from"react";import{forwardRef as A,createElement as B}from"react";var g=e=>e.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),p=(...e)=>e.filter((t,u,r)=>!!t&&r.indexOf(t)===u).join(" ");import{forwardRef as k,createElement as S}from"react";var h={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var w=k(({color:e="currentColor",size:t=24,strokeWidth:u=2,absoluteStrokeWidth:r,className:o="",children:s,iconNode:i,...m},L)=>S("svg",{ref:L,...h,width:t,height:t,stroke:e,strokeWidth:r?Number(u)*24/Number(t):u,className:p("lucide",o),...m},[...i.map(([I,x])=>S(I,x)),...Array.isArray(s)?s:[s]]));var d=(e,t)=>{let u=A(({className:r,...o},s)=>B(w,{ref:s,iconNode:t,className:p(`lucide-${g(e)}`,r),...o}));return u.displayName=`${e}`,u};var l=d("CirclePause",[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}],["line",{x1:"10",x2:"10",y1:"15",y2:"9",key:"c1nkhi"}],["line",{x1:"14",x2:"14",y1:"15",y2:"9",key:"h65svq"}]]);var f=d("CirclePlay",[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}],["polygon",{points:"10 8 16 12 10 16 10 8",key:"1cimsy"}]]);var c=d("CreditCard",[["rect",{width:"20",height:"14",x:"2",y:"5",rx:"2",key:"ynyp8z"}],["line",{x1:"2",x2:"22",y1:"10",y2:"10",key:"1b3vmo"}]]);var n=d("Plus",[["path",{d:"M5 12h14",key:"1ays0h"}],["path",{d:"M12 5v14",key:"s699le"}]]);var F=({cardNumber:e,expiryDate:t,cvv:u,"data-id":r})=>{let[o,s]=P(!1),[i,m]=P(!1),L=C=>C.match(/.{1,4}/g)?.join(" ")||C,I=()=>{s(!o)},x=()=>{alert("New card request initiated")};return a.createElement("div",{className:"max-w-md mx-auto p-4 space-y-4","data-id":r},a.createElement("div",{className:"relative"},a.createElement("div",{className:`relative bg-gradient-to-r from-[#754acd] to-[#e33ca8] rounded-xl p-6 text-white shadow-lg transition-all duration-300 ${o?"opacity-90":""}`},a.createElement("div",{className:"flex justify-between items-start mb-8"},a.createElement("div",{className:"space-y-1"},a.createElement("img",{src:"https://uploadthingy.s3.us-west-1.amazonaws.com/eGxVfcStjhYAnEhm8oYsqB/Cauri_logo_white_transparent_trimmed.png",alt:"Cauri",className:"h-10 w-auto"}),a.createElement("p",{className:"text-sm opacity-80"},"Bank with Purpose")),a.createElement(c,{className:"h-8 w-8"})),a.createElement("div",{className:"space-y-4"},a.createElement("div",null,a.createElement("p",{className:"text-sm opacity-80"},"Card Number"),a.createElement("p",{className:"font-mono text-lg"},i?L(e):"\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 "+e.slice(-4))),a.createElement("div",{className:"flex justify-between"},a.createElement("div",null,a.createElement("p",{className:"text-sm opacity-80"},"Expiry Date"),a.createElement("p",{className:"font-mono"},i?t:"\u2022\u2022/\u2022\u2022")),a.createElement("div",null,a.createElement("p",{className:"text-sm opacity-80"},"CVV"),a.createElement("p",{className:"font-mono"},i?u:"\u2022\u2022\u2022"))))),o&&a.createElement("div",{className:"absolute inset-0 bg-blue-100/30 backdrop-blur-[2px] rounded-xl pointer-events-none"},a.createElement("div",{className:"absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-200/20 rounded-xl"}),a.createElement("div",{className:"absolute inset-0",style:{background:`repeating-linear-gradient(
                -45deg,
                rgba(255, 255, 255, 0.1),
                rgba(255, 255, 255, 0.1) 5px,
                transparent 5px,
                transparent 10px
              )`}}))),a.createElement("div",{className:"flex justify-between gap-2 mt-4"},a.createElement("button",{onClick:()=>m(!i),className:"flex-1 px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"},i?"Hide Details":"Show Details"),a.createElement("button",{onClick:I,className:`flex-1 px-4 py-2 rounded-lg transition-colors flex items-center justify-center gap-2 ${o?"bg-[#754acd] text-white hover:bg-opacity-90":"bg-gray-100 hover:bg-gray-200"}`},o?a.createElement(a.Fragment,null,a.createElement(f,{className:"h-4 w-4"}),"Unfreeze"):a.createElement(a.Fragment,null,a.createElement(l,{className:"h-4 w-4"}),"Freeze")),a.createElement("button",{onClick:x,className:"flex-1 px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"},a.createElement(n,{className:"h-4 w-4"}),"New Card")))};export{F as CardManagement};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/circle-pause.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/circle-play.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/credit-card.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/plus.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
